import { render, staticRenderFns } from "./ModalConfig.vue?vue&type=template&id=082d835b"
import script from "./ModalConfig.vue?vue&type=script&lang=js"
export * from "./ModalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports